var cell_default = {
  "cell": "xSBOn",
  "header": "PLH7d",
  "selected": "k6stj",
  "editing": "_1EfwW",
  "singleSelection": "l8eK-",
  "hideLastBlock": "aIz56",
  "editorWrapper": "b3SOc",
  "viewerWrapper": "_2sVdB",
  "hideFirstBlock": "THkaH",
  "editor": "vonc4",
  "edit": "d44Q6",
  "view": "d8vWa",
  "editingToolbarWrapper": "ZMy8t",
  "selectAll": "_7RXxx",
  "disableSelection": "_8IIge"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
